// NOTE: Language
export const SET_LANG = 'SET_LANG'
// NOTE: Login State
export const SET_IS_LOGIN = 'SET_IS_LOGIN'
export const SET_LOGINED_BY = 'SET_LOGINED_BY'
export const DELETE_LOGINED_BY = 'DELETE_LOGINED_BY'
// NOTE: Loading State
export const ADD_LOADING_STATE = 'ADD_LOADING_STATE'
export const DELETE_LOADING_STATE = 'DELETE_LOADING_STATE'
// NOTE: toasts
export const ADD_TOASTS_DATA = 'ADD_TOASTS_DATA'
export const DELETE_TOASTS_DATA = 'DELETE_TOASTS_DATA'
export const COUNT_DOWN_TOASTS_TIME = 'COUNT_DOWN_TOASTS_TIME'
// NOTE: timezone
export const SET_TIME_ZONE = 'SET_TIME_ZONE'
